<template>
	<div class="index">
		<div class="chat-list">
			<div class="nav-title">秘书台</div>
			<div class="chat-list-user">
				<div v-for="(item, index) in chatList" :key="index" @click="lookChatRecords(index, item)">
					<div class="user-info" :class="current == index ? 'active-background' : ''">
						<span>{{ item.name }}</span>
						<!-- 模块级未读数 -->
						<!-- <span class="module-unread-count" v-if="getModuleUnreadCount(item) > 0">
							{{ getModuleUnreadCount(item) }}
						</span> -->
						
						<!-- 箭头：只有当通道没有未读消息时才能点击 -->
						<i v-if="!item.isShow && !item.keepOpen" 
						   class="el-icon-arrow-down arrow-icon" 
						   :class="{'arrow-disabled': hasModuleUnread(item)}"
						   :style="{ pointerEvents: hasModuleUnread(item) ? 'none' : 'auto', opacity: hasModuleUnread(item) ? 0.5 : 1 }"
						   @click.stop="toggleModule(index, item)"></i>
						<i v-if="item.isShow || item.keepOpen" 
						   class="el-icon-arrow-up arrow-icon" 
						   :class="{'arrow-disabled': hasModuleUnread(item)}"
						   :style="{ pointerEvents: hasModuleUnread(item) ? 'none' : 'auto', opacity: hasModuleUnread(item) ? 0.5 : 1 }"
						   @click.stop="toggleModule(index, item)"></i>

						<!-- 模块红点 -->
						<!-- <span class="module-red-dot" v-if="hasModuleUnread(item) && !item.keepOpen"></span> -->
					</div>

					<ul class="user-sub-list" :key="`sub-list-${item.id}`">
						<template v-for="(subItem, subindex) in item.children">
							<li v-if="subItem && (subItem.noRead || (item.isShow || (item.keepOpen && subItem.id == groupId)))" 
								:key="`child-${subItem.id}`"
								@click.stop="selectGroup(subItem, index, subindex)" class="subItem-li"
								:class="groupId == subItem.id ? 'active-subItem-li' : ''">
								<!-- 群组名称 -- 已解散 -->
								<span class="groupName-box">{{ subItem.groupName }}</span>
								<!-- 红点提示 --已解散也有红点提示的-->
								<span class="red-dot" v-if="subItem.noRead"></span>
								 
								<span v-if="subItem.isDissolve" class="kickout-tag">解散</span>
								<span v-if="subItem.status == 2 && !subItem.isDissolve" class="kickout-tag">移出</span>								
							</li>
						</template>
					</ul>



					<!-- <ul v-show="item.isShow" class="user-sub-list" :key="index">
						<li v-for="(subItem, subindex) in item.children" :key="subindex"
							@click.stop="selectGroup(subItem, index, subindex)" class="subItem-li"
							:class="groupId == subItem.id ? 'active-subItem-li' : ''">
							<span class="groupName-box">{{ subItem.groupName }} </span>
							
							<span class="red-dot" v-if="subItem.noRead"></span>
						</li>
					</ul> -->
				</div>
			</div>
		</div>
		<div v-if="isShow" class="default">
			<img src="@/assets/images/logo@3x.png" />
		</div>
		<spider-window-messagebox ref="messagebox" v-else />
	</div>
</template>

<script>
	import spiderWindowMessagebox from "../../../components/spider-window-message/spider-window-messagebox.vue";
	import {
		mapState
	} from "vuex";

	export default {
		components: {
			spiderWindowMessagebox
		},
		computed: {
			...mapState({
				RongIMClient: (state) => state.rongyun.RongIMClient, //融云实例
				updateGroupStatus: (state) => state.updateNum.updateGroupStatus, //刷新数组列表
				targetId: (state) => state.rongyun.targetId, //当前聊天的目标id
			}),
		},
		data() {
			return {
				current: null,
				isShow: true,
				isInitialLoad: true,  // 标记是否为初始化加载
				chatList: [{
					id: 1,
					name: "会议",
					isShow: false,
					keepOpen: false,
					children: [],
				},
				{
					id: 2,
					name: "活动",
					isShow: false,
					keepOpen: false,
					children: [],
				},
				{
					id: 3,
					name: "婚礼",
					isShow: false,
					keepOpen: false,
					children: [],
				},
				{
					id: 4,
					name: "宴席",
					isShow: false,
					keepOpen: false,
					children: [],
				},
				{
					id: 5,
					name: "殡礼",
					isShow: false,
					keepOpen: false,
					children: [],
				},
				{
					id: 6,
					name: "庆典",
					isShow: false,
					keepOpen: false,
					children: [],
				},
				{
					id: 7,
					name: "生日会",
					isShow: false,
					keepOpen: false,
					children: [],
				},
				{
					id: 8,
					name: "群聊",
					isShow: false,
					keepOpen: false,
					children: [],
				},
			],
				groupId: null,
				watchListStatus: 0,
				unReadGroupNum: 0, //未读群组数量
				loginMsg: {}
			};
		},
		
		// 在 mounted 钩子中添加监听初始化
		mounted() {
			const timestamp = new Date().toLocaleTimeString();
			console.log(`[${timestamp}] secretaryStation组件已挂载`);
			// 不再初始化时自动检查未读消息，避免红点消失
			console.log(`[${timestamp}] 跳过初始化时检查未读消息，避免红点消失`);

			// 监听群组消息，包括红包消息
			this.$root.$on('new-group-message', this.handleGroupMessage);
			console.log(`[${timestamp}] new-group-message事件监听器已添加`);

			 // 监听群解散消息
			 this.$root.$on('group-dissolve-message', this.handleGroupDissolveMessage);
			 console.log(`[${timestamp}] group-dissolve-message事件监听器已添加`);

			// 监听用户被移出群聊消息
			this.$root.$on('group-kickout-message', this.handleGroupKickoutMessage);
			console.log(`[${timestamp}] group-kickout-message事件监听器已添加`);
			
			// 监听秘书台未读消息更新事件
			this.$root.$on('secretary-unread-updated', this.handleSecretaryUnreadUpdated);
			console.log(`[${timestamp}] secretary-unread-updated事件监听器已添加`);
			
			// 监听全局未读消息状态变化
			this.$store.watch(
				(state) => state.updateNum.updateGroupStatus,
				(newVal, oldVal) => {
					const watchTimestamp = new Date().toLocaleTimeString();
					console.log(`[${watchTimestamp}] 检测到全局未读消息状态变化，重新计算秘书台未读数`);
					console.log(`[${watchTimestamp}] updateGroupStatus新值: ${newVal}, 旧值: ${oldVal}`);
					this.computedRedDot();
				}
			);
		},
		
		// 在beforeDestroy钩子中移除事件监听器
		beforeDestroy() {
			const timestamp = new Date().toLocaleTimeString();
			console.log(`[${timestamp}] secretaryStation组件即将销毁，移除事件监听器`);
			// 移除事件监听器
			this.$root.$off('new-group-message', this.handleGroupMessage);
			this.$root.$off('group-dissolve-message', this.handleGroupDissolveMessage);
			this.$root.$off('group-kickout-message', this.handleGroupKickoutMessage);
			this.$root.$off('secretary-unread-updated', this.handleSecretaryUnreadUpdated);
			console.log(`[${timestamp}] 事件监听器已移除`);
		},
		created() {
			//获取当前的个人信息 用来给发送添加头像 不需要请求
			this.loginMsg = JSON.parse(localStorage.getItem('loginMsg'))
			this.setChatListChildren(); //获取每个群组相关
		},
		// 组件激活时重新计算红点
		activated() {
			const timestamp = new Date().toLocaleTimeString();
			console.log(`[${timestamp}] === secretaryStation: 组件被激活 ===`);
			// 延迟展开有未读消息的通道，确保数据已加载
			setTimeout(() => {
				this.expandChannelsWithUnread();
			}, 500);
		},
		watch: {
			// watchListStatus(newVal, oldVal) {
			//   let arr = [];
			//   this.chatList.forEach((item, index) => {
			//     if (item.children.length > 0) {
			//       item.children.forEach((p) => {
			//         if (p.isFirst) {
			//           arr.push(index);
			//           this.$set(item, "isShow", true);
			//         }
			//       });
			//     }
			//   });
			//   if (arr.length > 0) {
			//     this.current = arr[0];
			//   }
			// },
			//监听刷新列表
			updateGroupStatus(newVal, oldVal) {
				oldVal = newVal
				//刷新群组列表
				this.setChatListChildren()
			},
			//监听融云实例
			RongIMClient(newVal, oldVal) {
				oldVal = newVal;
			},
			//目标id
			targetId(newVal, oldVal) {
				oldVal = newVal;
			}
		},
		methods: {
			// 自动展开有新消息的通道（仅在组件激活时执行一次，用于显示已有未读消息）
			expandChannelsWithUnread() {
				const timestamp = new Date().toLocaleTimeString();
				console.log(`[${timestamp}] === secretaryStation: 检查并展开有未读消息的通道 ===`);
				
				this.chatList.forEach((module, index) => {
					if (module.children && module.children.length > 0) {
						// 检查该通道是否有未读消息（排除当前正在聊天的群组）
						const hasUnread = module.children.some(child => child.noRead && child.id !== this.targetId);
						if (hasUnread) {
							// 有未读消息，自动设置keepOpen为true，展开通道
							if (!module.keepOpen) {
								this.$set(module, 'keepOpen', true);
								console.log(`[${timestamp}] === secretaryStation: 通道 ${module.name} 有未读消息，自动展开 ===`);
							}
						}
					}
				});
			},
			// 判断是否应该显示无未读消息的子项
			shouldShowNormalChildren(item) {
				// 如果模块是展开状态(isShow为true)，显示所有子项
				if (item.isShow) {
					return true;
				}
				// 如果模块被设置为保持打开状态(keepOpen为true)，只显示有未读消息的子项
				// 这样可以确保点击有新消息的群聊后，该群聊仍然显示在通道下面
				if (item.keepOpen) {
					return false;
				}
				// 如果模块是收起状态，只显示有未读消息的子项
				return false;
				
				
				//   // 如果模块被设置为保持打开状态，则始终显示
				// if (item.keepOpen) {
				//  return true;
				// }
				// // 如果是初始加载，只显示有未读消息的模块展开的子项
				// if (this.initialLoad) {
				//  // 检查该模块是否有未读消息
				//  const hasUnread = item.children && item.children.some(child => child.noRead);
				// 	return hasUnread && item.isShow;
				// }
				// // 非初始加载时，按照原来的逻辑显示
				// return item.isShow;
			},
			// 查看对应用户聊天记录
		lookChatRecords(index, item) {
			// 如果通道有未读消息，整个通道区域都不能点击
			if (this.hasModuleUnread(item)) {
				console.log('通道有未读消息，通道区域不能点击');
				return;
			}

			// 切换展开/收起状态，与箭头点击逻辑一致
			if (item.isShow || item.keepOpen) {
				// 如果已展开或有未读消息状态，则收起
				item.isShow = false;
				item.keepOpen = false; // 同时取消 keepOpen 状态
				this.current = null;
				this.groupId = null;
				console.log('收起模块，通道点击收起');
			} else {
				// 收起其他模块
				if (this.current !== null && this.current !== index) {
					this.chatList[this.current].isShow = false;
					this.chatList[this.current].keepOpen = false; // 同时取消其他模块的 keepOpen 状态
				}
				
				// 展开当前模块
				item.isShow = true;
				this.current = index;
				console.log('展开模块，通道点击展开');
			}
		},
			// 点击箭头切换模块展开/收起
			toggleModule(index, item) {
				// 如果通道有未读消息，不能点击箭头
				if (this.hasModuleUnread(item)) {
					console.log('通道有未读消息，箭头不能点击');
					return;
				}
				
				// 切换展开/收起状态
				if (item.isShow || item.keepOpen) {
					// 如果已展开或有未读消息状态，则收起
					item.isShow = false;
					item.keepOpen = false; // 同时取消 keepOpen 状态
					this.current = null;
					this.groupId = null;
					console.log('收起模块，箭头点击收起');
				} else {
					// 如果已收起，则展开
					item.isShow = true;
					this.current = index;
					console.log('展开模块，箭头点击展开');
				}
			},
			// 获取有未读消息的子项
			getUnreadChildren(children) {
				// 只包含有未读消息的群组
				if (!children || !Array.isArray(children)) {
					return [];
				}
				return children.filter(child => child && child.noRead);
			},
			
			// 获取无未读消息的子项，包括当前正在聊天的群组
			getNormalChildren(children) {
				if (!children || !Array.isArray(children)) {
					return [];
				}
				return children.filter(child => child && (!child.noRead || child.id == this.groupId));
			},
			//选择子列表 展示群组成员, 选择群组时检查是否已解散
			selectGroup(item, index, subIndex) {
				console.log('点击群聊通道，只取消红点并打开聊天窗口，保持通道展开');

				// 检查群组是否已解散
				if (item.isDissolve) {
					this.$message({
						message: '群已解散',
						type: 'warning',
						duration: 3000
					});
					this.clearRedDot(item);// 清除红点并减少未读数
					this.dissolveGroup(item); // 解散群组
					return; // 已解散的群组不允许进入聊天
				}

				// 检查用户是否被移出群聊
				if (item.status == 2) {
					this.$message({
						message: '您已被移出',
						type: 'warning',
						duration: 3000
					});
					this.clearRedDot(item);// 清除红点并减少未读数

					// 延迟后从列表中移除被移出的群组
					setTimeout(() => {
						this.removeGroupFromList(item);
						// 再次计算未读数，确保秘书台入口红点及时取消
						this.computedRedDot();
					}, 3000);
					return; // 被移出的群组不允许进入聊天
				}

				// 只清除红点，不改变模块展开状态
				this.clearRedDot(item);
				
				// 打开右侧聊天窗口
				this.groupId = item.id;
				item.from = "group";
				item.targetId = item.id;
				this.isShow = false; //展示聊天框

				// 确保 messagebox 组件已经渲染完成
				this.$nextTick(() => {
					if (this.$refs.messagebox) {
						this.$refs.messagebox.init(item).then(() => {
							// 监听聊天窗口的关闭事件
							this.setupChatWindowCloseListener();
							// 加载本地存储的消息
							this.loadGroupMessagesFromLocal(item.id);
						});

						// 在聊天窗口打开后滚动到底部
						this.$nextTick(() => {
							setTimeout(() => {
								this.$refs.messagebox.toEnd && this.$refs.messagebox.toEnd();
							}, 200);
						});
					} else {
						console.error('messagebox 组件未渲染');
					}
				});
			},
			// 设置聊天窗口关闭监听器
			setupChatWindowCloseListener() {
				// 监听路由变化（用户可能通过路由切换离开聊天窗口）
				this.$router.afterEach((to, from) => {
					if (from.path.includes('/secretaryStation') && !to.path.includes('/secretaryStation')) {
						console.log('检测到离开秘书台聊天窗口');
						this.$emit('chat-window-closed');
					}
				});
				
				// 监听浏览器标签页切换（用户可能切换到其他标签页）
				document.addEventListener('visibilitychange', () => {
					if (document.hidden) {
						console.log('检测到切换到其他标签页');
						this.$emit('chat-window-closed');
					}
				});
			},
			loadGroupMessagesFromLocal(groupId) {
				const groupMessages = JSON.parse(localStorage.getItem(`groupMessages_${groupId}`) || '[]');
    
				if (groupMessages.length > 0 && this.$refs.messagebox) {
					// 将消息加载到聊天窗口
					groupMessages.forEach(message => {
						// 这里需要根据实际的消息显示逻辑进行调整
						// this.$refs.messagebox.addMessageToDisplay(message);
					});
				}  
			},
			//设置秘书台的子列表
			setChatListChildren() {
				let arr = [];
				this.chatList.forEach((item) => {
					//获取群组相关列表  类型 0默认群聊 1会议 2活动 3婚礼4宴席5殡礼6庆典7生日会
					this.$api.group.groupGroupInfoList(item.id).then((res) => {
						//设置子列表
					res.result.forEach((p) => {
						this.$set(p, "id", p.id.toString());
						this.$set(p, "memberId", p.memberId.toString());
						arr.push(item);
						this.watchListStatus = arr.length;
						
						// 获取该群组的未读状态
						this.updateGroupNoReadStatus(p);
					});
						const list = (res.result || []);
						this.$set(item, "children", list.reverse());
						
						// 数据加载完成后，自动展开有未读消息的通道
						this.$nextTick(() => {
							this.expandChannelsWithUnread();
						});
					});
				});
			},
			
			// 更新单个群组的未读状态
			updateGroupNoReadStatus(group) {
				try {
					const conversation = this.RongIMClient.Conversation.get({
						targetId: group.id,
						type: window.RongIMLib.CONVERSATION_TYPE.GROUP,
					});
					
					if (conversation && typeof conversation.getUnreadCount === 'function') {
						const count = conversation.getUnreadCount();
						if (count && typeof count.then === 'function') {
							count.then((actualCount) => {
								// 如果当前正在该群聊天，不显示红点
								const hasUnread = actualCount > 0 && this.targetId != group.id;
								this.$set(group, 'noRead', hasUnread);
								console.log(`更新群组 ${group.groupName} 未读状态: ${hasUnread}`);
							});
						} else {
							// 如果当前正在该群聊天，不显示红点
							const hasUnread = count > 0 && this.targetId != group.id;
							this.$set(group, 'noRead', hasUnread);
							console.log(`更新群组 ${group.groupName} 未读状态: ${hasUnread}`);
						}
					}
				} catch (error) {
					console.error(`获取群组 ${group.id} 未读状态失败:`, error);
				}
			},
			//清除红点
		clearRedDot(val) {
				// 清除未读数
				let conversation = this.RongIMClient.Conversation.get({
					targetId: val.id,
					type: window.RongIMLib.CONVERSATION_TYPE.GROUP,
				});
				if (conversation) {
					conversation.read().then(() => {
						console.log("清除指定会话未读数成功");
						// this.computedRedDot()
						this.unReadGroupNum = Math.max(0, this.unReadGroupNum - 1)
						this.$store.commit('updateGroumNum', this.unReadGroupNum)

						// 清除单个群组红点和计数
						this.$set(val, 'noRead', false);
						this.$set(val, 'unreadCount', 0);
						// 发送同步消息
						conversation.send({
							messageType: "RC:SRSMsg",
							content: {
								//从消息里获取服务器端时间，以最近一条已读 message 为准
								// lastMessageSendTime: message.sentTime,
							},
						}).then((message) => {
							// console.log("发送同步消息成功", message);
						});

						// 检查该通道是否还有其他未读消息
						setTimeout(() => {
							this.checkChannelUnreadStatus();
							// 延迟更新Vuex状态，确保融云SDK的未读数已经更新
							setTimeout(() => {
								// 重新计算未读数，确保秘书台入口红点及时取消
								this.computedRedDot();
							}, 1000);
						}, 500);
					}).catch(error => {
						console.error('清除未读数失败:', error);
					});
				}
			},
			// 检查通道未读状态
			checkChannelUnreadStatus() {
				// 不再自动重置 keepOpen 状态，群聊会一直显示在通道底下
				// 只有用户主动点击通道或箭头时，才能收起通道
				// 检查每个通道是否还有未读消息，用于更新箭头样式
				this.chatList.forEach(module => {
					const hasUnread = module.children.some(child => child.noRead);
					// 如果通道没有未读消息，箭头变为可点击状态
					// 但 keepOpen 状态保持不变，群聊继续显示在通道底下
					if (!hasUnread && module.keepOpen) {
						console.log(`通道 ${module.name} 没有未读消息，箭头变为可点击状态`);
					}
				});
			},
			// 处理秘书台未读消息更新事件
		handleSecretaryUnreadUpdated(event) {
			const timestamp = new Date().toLocaleTimeString();
			console.log(`[${timestamp}] === secretaryStation: 收到秘书台未读消息更新事件 ===`);
			console.log(`[${timestamp}] === secretaryStation: 事件数据:`, event);
			// 只有在初始化或群组列表发生变化时才重新计算未读数
			// 避免在收到新消息时重复计算，导致闪现
			if (!event || !event.groupId) {
				console.log(`[${timestamp}] === secretaryStation: 初始化或列表变化，重新计算未读数 ===`);
				this.computedRedDot();
			} else {
				console.log(`[${timestamp}] === secretaryStation: 收到新消息，跳过重复计算 ===`);
			}
		},
		
		// 计算每个群组的红点
		computedRedDot() {
			const timestamp = new Date().toLocaleTimeString();
			console.log(`[${timestamp}] === secretaryStation: 开始计算秘书台未读数 ===`);
			let count = 0; // 不重置为0，而是基于本地状态计算
			let processedGroups = 0;
			let unreadGroups = 0;
			
			// 同步处理，避免多次DOM更新
			this.chatList.forEach((item, index) => {
				if (item.children && item.children.length > 0) {
					console.log(`[${timestamp}] === secretaryStation: 处理模块 ${item.name}，共有 ${item.children.length} 个群组 ===`);
					item.children.forEach((child) => {
						processedGroups++;

						// 跳过已解散或被移出的群组
						if (child.isDissolve || child.status == 2) {
							if (!child.noRead) {
								this.$set(child, 'noRead', true);
							}
							count += 1;
							unreadGroups++;
							console.log(`[${timestamp}] === secretaryStation: 群组 ${child.groupName} 已解散或被移出，跳过未读数计算 ===`);
							return;
						}
						
						// 基于本地状态计算未读数量，不再从融云SDK获取
						if (child.noRead) {
							count++;
							unreadGroups++;
						}
					});
				}
			});

			// 更新组件内部变量和Vuex状态
			this.unReadGroupNum = count;
			console.log(`[${timestamp}] === secretaryStation: 更新Vuex中的秘书台未读数为 ${count} ===`);
			this.$store.commit('updateGroumNum', count);
			console.log(`[${timestamp}] === secretaryStation: 秘书台未读数更新完成：处理群组总数 ${processedGroups}, 未读群组数量 ${unreadGroups} ===`);
		},
			//签到
			signIn(val) {
				// console.log(val)
				this.$api.member.signIn(val.id).then(res => {
					val.signInFlag = true
					this.$message({
						message: '签到成功',
						type: 'success'
					});
				})
			},
			// 解散群组方法
			dissolveGroup(group) {
				// this.$confirm('确定要解散该群组吗？', '警告', {
				// 	confirmButtonText: '确定',
				// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(() => {
					 // 检查 RongIMClient 是否存在
					// if (!this.RongIMClient) {
					// 	console.error('RongIMClient 未初始化');
					// 	this.$message.error('融云实例未初始化，无法解散群组');
					// 	return Promise.reject(new Error('融云实例未初始化'));
					// }
					// this.RongIMClient.Group.dismiss(group.id.toString()).then((res) => {
					//     console.log('res');
					// 	return
					// }).catch(err=>{
					// 	console.warn('会话对象的 dismiss 方法不存在，跳过融云端解散', err);
					// 	return
					// });
					
					
					this.$api.group.dissolveGroup(group.id)

					// .then(res => {
					// 	return this.RongIMClient.Group.dismiss(group.id.toString());
					// })
					.then(() => {
						// 2. 从本地列表中移除已解散的群组
						const index = this.chatList.findIndex(item =>
							item.children.some(child => child.id === group.id));
						if (index > -1) {
							this.chatList[index].children = this.chatList[index].children
								.filter(child => child.id !== group.id);
						}

						// 3. 显示成功提示
						// this.$message({
						// 	message: '群组解散成功',
						// 	type: 'success'
						// });

					})
					.catch(error => {
						// 处理错误
						console.error('解散失败:', error);
						let errorMsg = '解散群组失败';
						if (error.code) {
							errorMsg = this.$t(`rongYunErro.${error.code}`) || errorMsg;
						}
						this.$message.error(errorMsg);
					});
				// });
			},
			
			// 关闭融云群组通道
		closeRongyunChannel(groupId) {
			const conversation = this.RongIMClient.Conversation.get({
				targetId: groupId.toString(),
				type: window.RongIMLib.CONVERSATION_TYPE.GROUP
			});
					console.log('conversation', conversation);
				conversation.dismiss({
					groupId: groupId.toString(),
				}).then(() => {
					console.log('群组已解散');
				}).catch(error => {
					console.error('解散失败:', error);
					this.$message.error(this.$t(`rongYunErro.${error.code}`)); // 使用项目错误码映射
				});
			},
			// 处理实时群聊消息
		handleGroupMessage(message) {
			const timestamp = new Date().toLocaleTimeString();
			console.log(`[${timestamp}] === secretaryStation: 收到群消息 ===`);
			const groupId = message.targetId.toString();
			const currentTargetId = this.targetId ? this.targetId.toString() : '';
			
			// 1. 查找对应的群组
			let targetGroup = null;
			let targetModule = null;
			let moduleIndex = -1;
			
			this.chatList.forEach((module, index) => {
				const found = module.children.find(child => child.id === groupId);
				if (found) {
					targetGroup = found;
					targetModule = module;
					moduleIndex = index;
				}
			});
			
			if (targetGroup && targetModule) {
				console.log(`[${timestamp}] === secretaryStation: 找到群组: ${targetGroup.groupName} ===`);
				
				// 2. 保存消息到本地存储
				this.saveGroupMessageToLocal(groupId, message);
				
				// 3. 判断是否是当前正在聊天的群
				if (currentTargetId === groupId) {
					// 当前正在该群聊天，不显示红点，不展开通道
					console.log(`[${timestamp}] === secretaryStation: 当前正在 ${targetGroup.groupName} 聊天，不显示红点 ===`);
				} else {
					// 不是当前聊天的群，显示红点提示
					console.log(`[${timestamp}] === secretaryStation: 不是当前聊天的群，显示红点 ===`);
					
					// 更新群组未读状态
					if (!targetGroup.noRead) {
						this.$set(targetGroup, 'noRead', true);
						// 重新计算未读数量
						this.recalculateUnreadCount();
						console.log(`[${timestamp}] === secretaryStation: 群组 ${targetGroup.groupName} 未读状态更新完成 ===`);
					}
					
					// 注意：根据需求，通道收起状态时不必自动下拉展开
					// 所以这里不设置 keepOpen = true
					console.log(`[${timestamp}] === secretaryStation: 通道保持当前状态，不自动展开 ===`);
				}
			}
			
			// 4. 如果用户正在该群聊天，直接传递消息给聊天窗口
			if (currentTargetId === groupId && this.$refs.messagebox && this.$refs.messagebox.$refs.SpiderWindowMymessage) {
				// 调用handleGroupMessageInChat方法来处理消息（包含头像获取逻辑）
				this.$refs.messagebox.$refs.SpiderWindowMymessage.handleGroupMessageInChat(message);
				this.$refs.messagebox.toEnd();
			}
		},
		
		// 重新计算未读数量
		recalculateUnreadCount() {
			const timestamp = new Date().toLocaleTimeString();
			console.log(`[${timestamp}] === secretaryStation: 重新计算未读数量 ===`);
			let count = 0;
			
			// 计算所有未读群组数量（排除当前正在聊天的群组）
			this.chatList.forEach((module) => {
				if (module.children && module.children.length > 0) {
					module.children.forEach((child) => {
						// 如果当前正在该群聊天，不计入未读数量
						if (child.noRead && child.id !== this.targetId) {
							count++;
						}
					});
				}
			});
			
			// 更新组件内部变量和Vuex状态
			this.unReadGroupNum = count;
			this.$store.commit('updateGroumNum', count);
			console.log(`[${timestamp}] === secretaryStation: 未读数量重新计算完成，当前未读数量: ${count} ===`);
		},
			
			// 检查模块是否有未读
			hasModuleUnread(module) {
				return module.children.some(child => child.noRead);
			},
			// 保存群组消息到本地存储
			saveGroupMessageToLocal(groupId, message) {
				// 获取现有的群组消息历史
				let groupMessages = JSON.parse(localStorage.getItem(`groupMessages_${groupId}`) || '[]');
				
				// 添加新消息
				groupMessages.push({
					messageId: message.messageId,
					content: message.content,
					senderUserId: message.senderUserId,
					sentTime: message.sentTime,
					messageType: message.messageType
				});
				
				// 限制保存的消息数量，避免存储过多
				if (groupMessages.length > 100) {
					groupMessages = groupMessages.slice(-100);
				}
				
				// 保存到本地存储
				localStorage.setItem(`groupMessages_${groupId}`, JSON.stringify(groupMessages));
			},
			
			// 处理群解散消息
			handleGroupDissolveMessage(message) {
				console.log('处理群解散消息', message);
				const groupId = message.targetId;
				
				// 查找对应的群组
				let targetGroup = null;
				let targetModule = null;
				let moduleIndex = -1;
				
				this.chatList.forEach((module, index) => {
					const found = module.children.find(child => child.id === groupId);
					if (found) {
						targetGroup = found;
						targetModule = module;
						moduleIndex = index;
					}
				});
				
				if (targetGroup && targetModule) {
					// 1. 设置群组解散状态
					this.$set(targetGroup, 'isDissolve', true);
					
					// 2. 设置红点：显示群解散提示
					this.$set(targetGroup, 'noRead', true);
					
					// 3. 自动展开当前模块
					if (!targetModule.isShow && !targetModule.keepOpen) {
						this.$set(targetModule, 'isShow', true);
						this.current = moduleIndex;
					}
					
					// 4. 更新未读数
					console.log('收到群解散消息，重新计算未读数');
					this.computedRedDot();
					
					// 5. 显示解散提示
					console.log(`群组 ${targetGroup.groupName} 已解散`);
				}
			},
			
			// 处理用户被移出群聊消息
			handleGroupKickoutMessage(message) {
				console.log('处理用户被移出群聊消息', message);
				const groupId = message.targetId;
				
				// 查找对应的群组
				let targetGroup = null;
				let targetModule = null;
				let moduleIndex = -1;
				
				this.chatList.forEach((module, index) => {
					const found = module.children.find(child => child.id === groupId);
					if (found) {
						targetGroup = found;
						targetModule = module;
						moduleIndex = index;
					}
				});
				
				if (targetGroup && targetModule) {
					// 1. 设置用户被移出状态
					this.$set(targetGroup, 'status', 2);
					
					// 2. 设置红点：显示被移出提示
					this.$set(targetGroup, 'noRead', true);
					
					// 3. 自动展开当前模块（只有在有聊天窗口的情况下）
					if (this.isShow) {
						// 无聊天窗口的情况下，保持模块关闭状态，箭头向下
						console.log('无聊天窗口，保持模块关闭状态');
						// 确保模块关闭，箭头向下
						if (targetModule.isShow) {
							this.$set(targetModule, 'isShow', false);
						}
					} else {
						// 有聊天窗口的情况下，自动展开模块
						if (!targetModule.isShow && !targetModule.keepOpen) {
							this.$set(targetModule, 'isShow', true);
							this.current = moduleIndex;
						}
					}
					
					// 4. 更新未读数
					console.log('收到用户被移出群聊消息，重新计算未读数');
					this.computedRedDot();
				}
			},

			// 从列表中移除群组（被移出）
			removeGroupFromList(group) {
				console.log('从列表中移除群组:', group.id);
				
				// 从本地存储的kickedGroups中移除该群组
				const kickedGroups = JSON.parse(localStorage.getItem('kickedGroups') || '[]');
				const updatedKickedGroups = kickedGroups.filter(id => id !== group.id);
				localStorage.setItem('kickedGroups', JSON.stringify(updatedKickedGroups));
				console.log('从被移出列表中移除群组:', group.id);

				this.$api.group.quitGroupGroup(group.id).then(() => {
					// 2. 从本地列表中移除被移出的群组
					const index = this.chatList.findIndex(item =>
						item.children.some(child => child.id === group.id));
					if (index > -1) {
						this.chatList[index].children = this.chatList[index].children
							.filter(child => child.id !== group.id);
					}
					
					// 重新计算未读数，确保秘书台入口红点及时取消
					console.log('群组已从列表中移除，重新计算未读数');
					this.computedRedDot();
					
					// 触发秘书台未读更新事件，确保slider-bar也更新
					this.$root.$emit('secretary-unread-updated', {
						groupId: group.id,
						timestamp: Date.now()
					});
				})
				.catch(error => {
					// 处理错误
					console.error('移出失败:', error);
					let errorMsg = '移出群组失败';
					if (error.code) {
						errorMsg = this.$t(`rongYunErro.${error.code}`) || errorMsg;
					}
					this.$message.error(errorMsg);
				});
			},
		},
	};
</script>

<style scoped>
	.index {
		display: flex;
		flex: 1;
	}

	.chat-list {
		width: 253px;
		user-select: none;
		cursor: pointer;
		height: 100%;
		background: #ffffff;
	}

	.chat-list .chat-list-user {
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		padding-bottom: 100px;
	}

	.nav-title {
		height: 60px;
		line-height: 60px;
		font-size: 18px;
		letter-spacing: 2px;
		padding: 10px;
		display: flex;
		align-items: center;
		background: #f5f7fa;
		box-sizing: border-box;
		border-bottom: 1px solid #dcdfe6;
	}

	.chat-list-user .user-info {
		height: 38px;
		line-height: 38px;
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #7b7d80;
		/* padding: 0 12px; */
		border-bottom: 1px solid #dcdfe6;
		box-sizing: border-box;
		padding: 0 15px;
		justify-content: space-between;
		position: relative;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: all 0.2s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	.user-sub-list {
		display: flex;
		height: auto;
		flex-direction: column;
	}

	.user-sub-list li {
		flex-shrink: 0;
		height: 40px;
		align-items: center;
		position: relative;
		font-size: 16px;
	}

	/* .user-sub-list li:hover {
      background: #ffffff;
    } */
	.user-info:hover {
		background: #f5f7fa;
	}
	
	.arrow-icon {
		cursor: pointer;
	}
	
	.arrow-disabled {
		color: #c0c4cc;
		cursor: not-allowed;
		pointer-events: none;
	}

	.active-background {
		/* height: 38px; */
		line-height: 38px;
		font-size: 14px;
		color: #7b7d80;
		/* background: #f5f7fa; */
		/* padding: 0 12px; */
		border-bottom: 1px solid #dcdfe6;
		box-sizing: border-box;
	}

	.default {
		min-width: 506px;
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-around;
		background: #f5f7fa;
		border-left: 1px solid #dcdfe6;
	}

	.default img {
		width: 100px;
		height: 100px;
	}

	.subItem-li {
		width: 100%;
		height: 57px;
		padding-left: 12px;
		font-size: 16px;
		font-family: PingFangSC, PingFangSC-Regular;
		font-weight: 400;
		color: #313233;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #dcdfe6;
	}

	.user-info-title {
		width: calc(100% - 24px);
		padding: 0 12px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.subItem-li:hover {
		background: #f5f7fa;
	}

	.active-subItem-li {
		background: #f5f7fa;
	}

	.active-subItem-li:hover {
		background: #f5f7fa;
	}

	.groupName-box {
		max-width: 210px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.red-dot {
		width: 5px;
		height: 5px;
		background: #ff0000;
		border-radius: 50%;
		margin-left: 15px;
		flex-shrink: 0;
	}
	.kickout-tag{
		position: absolute;    
		right: 18px;
		color: red;
		font-size: 14px;
	}
	.dissolve-tag{

	}

	.sign-box {
		margin-left: 20px;
		font-size: 12px;
		color: #666;
	}
	.dissolve-box {
		color: #4db4d4;
	}

	/* 模块未读数样式 */
	.module-unread-count {
		display: inline-block;
		min-width: 18px;
		height: 18px;
		line-height: 18px;
		text-align: center;
		background-color: #ff6632;
		color: white;
		border-radius: 9px;
		font-size: 12px;
		padding: 0 4px;
		margin-left: 5px;
	}

	.module-red-dot {
		display: inline-block;
		width: 8px;
		height: 8px;
		background-color: #ff6632;
		border-radius: 50%;
		margin-left: 5px;
	}

	.group-unread-count {
		display: inline-block;
		min-width: 16px;
		height: 16px;
		line-height: 16px;
		text-align: center;
		background-color: #ff6632;
		color: white;
		border-radius: 8px;
		font-size: 11px;
		padding: 0 3px;
		margin-left: 5px;
	}
</style>